export default {
  accessToken: 'accessToken',
  isSourceOrganization: 'isSourceOrganization',
  // Upload types accepted by POST /uploads (UploadType enum in the API).
  UPLOAD_TYPES: {
    PROFILE_IMAGE: 'profile_image',
    HEALTH_CERTIFICATE: 'health_certificate',
    PET_FILE: 'pet_file',
    PET_MEDICAL_RECORD: 'pet_medical_record',
    MESSAGE_ATTACHMENT: 'message_attachment',
    TRANSPORT_REQUEST_ATTACHMENT: 'transport_request_attachment'
  }
};

